import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
} from "chart.js";
import { Pie, Bar, Line } from "react-chartjs-2";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement
);

export default function Dashboard() {

  const [user, setUser] = useState(null);
  useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const email = storedUser?.email;
      const level = storedUser?.level;
  
      fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
          .then((res) => res.json())
          .then((data) => {
              if (data.status === "success") {
              setUser(data.data);
              console.log("Respon api search email:", data.data);
              } else {
              console.error(data.message);
              }
          })
          .catch((err) => console.error(err));
    }, []);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const BASE = process.env.REACT_APP_BASE_URL || "";

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      setLoading(true);
      try {
        const res = await fetch(`${BASE}api/dashboard`);
        if (!res.ok) throw new Error("API error");
        const json = await res.json();
        if (mounted) setData(json);
      } catch (err) {
        console.error("Gagal fetch dashboard:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => (mounted = false);
  }, [BASE]);

  if (loading || !data) {
    return (
      <div className="p-6">
        <p className="text-gray-500">Loading dashboard...</p>
      </div>
    );
  }

  // Chart data
  const lineData = {
    labels: data.trends.map((t) => t.month),
    datasets: [
      {
        label: "Total Ajuan",
        data: data.trends.map((t) => t.total),
        borderColor: "#4f46e5",
        backgroundColor: "#4f46e5",
      },
      {
        label: "Sudah Transfer",
        data: data.trends.map((t) => t.transfered),
        borderColor: "#10b981",
        backgroundColor: "#10b981",
      },
    ],
  };

  const barData = {
    labels: data.summary.typeDistribution.map((t) => t.type),
    datasets: [
      {
        label: "Jumlah",
        data: data.summary.typeDistribution.map((t) => t.count),
        backgroundColor: "#06b6d4",
      },
    ],
  };

  const pieData = {
    labels: data.statusDistribution.map((s) => s.name),
    datasets: [
      {
        data: data.statusDistribution.map((s) => s.value),
        backgroundColor: ["#10b981", "#ef4444"],
      },
    ],
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold uppercase">Dashboard</h1>
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-500">
            Role: <strong className="uppercase">{user.level}</strong>
          </span>
          <button
            className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      </header>

      {/* Summary Cards */}
      <section className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card
          title="Total Ajuan (Bulan ini)"
          value={formatCurrency(data.summary.totalThisMonth)}
        />
        <Card
          title="Belum Print"
          value={data.summary.counts.byPrintStatus?.unread || 0}
        />
        <Card
          title="Belum Transfer"
          value={data.summary.counts.byTransferStatus?.untransfered || 0}
        />
        <Card title="Jenis Terbanyak" value={data.summary.topType || "-"}/>
      </section>

      {/* Charts */}
      <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="col-span-2 bg-white rounded shadow p-4">
          <h3 className="font-medium mb-3">Tren Pengajuan (6 bulan terakhir)</h3>
          <Line data={lineData} />
        </div>

        <div className="bg-white rounded shadow p-4">
          <h3 className="font-medium mb-3">Distribusi Tipe Ajuan</h3>
          <Bar data={barData} />
          <div className="w-48 h-48">
            <h3 className="font-medium mb-3 mt-6">Status Transfer</h3>
            <Pie data={pieData} />
          </div>
        </div>

      </section>

      {/* Recent Table & Notifications */}
      {/* <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded shadow p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-medium uppercase">Recent Ajuan</h3>
            <div className="flex gap-2">
              {user.level !== "event" && (
                <button className="text-sm px-3 py-1 border rounded">
                  Lihat Semua
                </button>
              )}
              {user.level === "event" && (
                <button className="text-sm px-3 py-1 bg-green-500 text-white rounded">
                  Buat Pengajuan
                </button>
              )}
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-gray-500 uppercase">
                  <th className="p-2">No</th>
                  <th className="p-2">Nomor</th>
                  <th className="p-2">Pemohon</th>
                  <th className="p-2">Tipe</th>
                  <th className="p-2">Jumlah</th>
                  <th className="p-2">Print</th>
                  <th className="p-2">Transfer</th>
                  <th className="p-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                {data.recent.map((r, i) => (
                  <tr key={r.id} className="border-t">
                    <td className="p-2">{i + 1}</td>
                    <td className="p-2">{r.number}</td>
                    <td className="p-2">{r.requester}</td>
                    <td className="p-2">{r.type}</td>
                    <td className="p-2">{formatCurrency(r.amount)}</td>
                    <td className="p-2">{r.printed ? "Sudah" : "Belum"}</td>
                    <td className="p-2">{r.transferred ? "Sudah" : "Belum"}</td>
                    <td className="p-2">
                      <div className="flex gap-2">
                        <button
                          className="text-xs px-2 py-1 border rounded"
                          onClick={() => alert(`Buka detail ${r.number}`)}
                        >
                          Detail
                        </button>
                        {user.level === "finance" && (
                          <>
                            <button
                              className="text-xs px-2 py-1 bg-indigo-600 text-white rounded"
                              onClick={() =>
                                alert(`Ubah status print ${r.number}`)
                              }
                            >
                              Toggle Print
                            </button>
                            <button
                              className="text-xs px-2 py-1 bg-emerald-600 text-white rounded"
                              onClick={() =>
                                alert(`Proses transfer ${r.number}`)
                              }
                            >
                              Transfer
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <aside className="bg-white rounded shadow p-4">
          <h3 className="font-medium mb-3 uppercase">Notifikasi / Reminder</h3>
          <ul className="space-y-3">
            {data.notifications.map((n) => (
              <li key={n.id} className="p-2 border rounded">
                <div className="text-sm font-medium">{n.title}</div>
                <div className="text-xs text-gray-500 mt-1">{n.detail}</div>
              </li>
            ))}
            {data.notifications.length === 0 && (
              <li className="text-sm text-gray-500">Tidak ada notifikasi</li>
            )}
          </ul>
        </aside>
      </section> */}

      <footer className="text-xs text-gray-500">
        * Data diambil dari API: <code>{`${BASE}api/dashboard`}</code>
      </footer>
    </div>
  );
}

// Komponen Card
function Card({ title, value }) {
  return (
    <div className="bg-white rounded shadow p-4 flex flex-col justify-between">
      <div className="text-sm text-gray-500 uppercase">{title}</div>
      <div className="mt-2 text-2xl font-semibold">{value}</div>
    </div>
  );
}

// Format Rupiah
function formatCurrency(val) {
  if (val == null) return "-";
  const n = Number(val) || 0;
  return n.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  });
}
